import { useEffect } from 'react';

type UseForeignSessionOpenNoticeParams = {
  isOpenModalActive: boolean;
  isSaving: boolean;
  hasActiveSession: boolean;
  onForeignOpen: () => void;
};

// Summary: Notifies + closes the open-cash modal when another device opens the session.
export function useForeignSessionOpenNotice({
  isOpenModalActive,
  isSaving,
  hasActiveSession,
  onForeignOpen,
}: UseForeignSessionOpenNoticeParams) {
  useEffect(() => {
    // isSaving suppresses our own open, whose SSE echo can land before confirmOpen nulls the mode.
    if (isOpenModalActive && hasActiveSession && !isSaving) {
      onForeignOpen();
    }
  }, [isOpenModalActive, hasActiveSession, isSaving, onForeignOpen]);
}
